const FEATURE_HELP_URLS = {
  agent_bots: 'https://redmasiva.com/hc/agent-bots',
  agents: 'https://redmasiva.com/hc/agents',
  audit_logs: 'https://redmasiva.com/hc/audit-logs',
  campaigns: 'https://redmasiva.com/hc/campaigns',
  canned_responses: 'https://redmasiva.com/hc/canned',
  channel_email: 'https://redmasiva.com/hc/email',
  channel_facebook: 'https://redmasiva.com/hc/fb',
  custom_attributes: 'https://redmasiva.com/hc/custom-attributes',
  dashboard_apps: 'https://redmasiva.com/hc/dashboard-apps',
  help_center: 'https://redmasiva.com/hc/help-center',
  inboxes: 'https://redmasiva.com/hc/inboxes',
  integrations: 'https://redmasiva.com/hc/integrations',
  labels: 'https://redmasiva.com/hc/labels',
  macros: 'https://redmasiva.com/hc/macros',
  message_reply_to: 'https://redmasiva.com/hc/reply-to',
  reports: 'https://redmasiva.com/hc/reports',
  sla: 'https://redmasiva.com/hc/sla',
  team_management: 'https://redmasiva.com/hc/teams',
  webhook: 'https://redmasiva.com/hc/webhooks',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
